import {
  defineCborSchema,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type MeshoutResponsePayload = {}

export const MeshoutResponsePayloadSchema: CborSchema<MeshoutResponsePayload> =
  defineCborSchema<MeshoutResponsePayload>({})
